import * as amplify from "./amplify.ts";
import * as FwDatas from "../FwDatas.ts";
import { localGet, localSet } from "../lib/Storage.ts";
import { BaseCache } from "../lib/SyncCache.ts";
import * as Html from "../util/Html.ts";
import Icons from "../svg/Icons.ts";
import * as modal from "./modal.ts";
import { registerDragStart } from "../lib/FileUtils.ts";

type MemberWithOrder = {sortingIndex:number,activated:boolean,member:any}
type MemberOrderMap = {[accountId:string]:{sortingIndex:number,activated:boolean}}
function getOrder() : MemberOrderMap{
  var order = JSON.parse(localGet('family.order'+FwDatas.getFamily().metaId)||"{}")
  var result = {}
  FwDatas.getFamily().members.forEach((member,idx)=>{
    return result[member.accountId] = order[member.accountId]||{sortingIndex:idx*10000,activated:true}
  })
  return result;
}
function saveOrder(order :MemberOrderMap){
  localSet('family.order'+FwDatas.getFamily().metaId,JSON.stringify(order))
}
export const MemberOrder = new BaseCache<MemberWithOrder[]>(()=>{
  return new Promise((resolve,reject)=>{
    var enrichedMember = Object.entries(getOrder()).map(([key,value])=>{
      return {
        activated:value.activated,
        sortingIndex:value.sortingIndex,
        member:FwDatas.getProfile(key)
      }
    });
    enrichedMember.sort((a,b)=>a.sortingIndex-b.sortingIndex)
    resolve(enrichedMember)
  })
})
export function clearMemberOrderFilter(){
  var order = getOrder()
  Object.entries(order).forEach(([key,value])=>{
    value.activated = true;
  })
  saveOrder(order);
  MemberOrder.invalidate()
}
export function memberToggleFilter(activated:boolean, ...memberIds:(string|number)[]){
  var 
    order = getOrder(),
    change = false;
  memberIds.forEach(memberId=>{
    if(order[memberId]!==undefined){
      change = order[memberId].activated !== activated
      order[memberId].activated = activated
    }
  })
  if(change){
    saveOrder(order)
    MemberOrder.invalidate()
    amplify.publish('familyMemberChange')
  }
}
Html.register({
  async memberordersettings(){
    var 
      TPL = await import("../calendar/member_order.mustache"),
      theModal = modal.openModal(TPL,{members:await MemberOrder.refresh()}),
      theButton = theModal.find('button').first();
    theButton.on('click',()=>{
      var 
        order = {},
        oneActivated = false;
      theModal.get(0).querySelectorAll('[data-fw-meta-id]').forEach((node,idx)=>{
        order[node.getAttribute('data-fw-meta-id')] = {
          sortingIndex:idx*1000,
          activated:node.getAttribute('activated')==='true'
        }
        oneActivated = oneActivated || node.getAttribute('activated')==='true'
      })
      if(oneActivated){
        saveOrder(order);
        modal.closeModal(theModal);
        amplify.publish('familyMemberChange')
      }else{
        modal.alert('calendarmember.errormustcheck')
      }
    })  
  },

  memberordertoggle(){
    var 
      activated = this.metaIdNode().attr('activated')!=='true';
    this.metaIdNode().attr('activated',activated)
    this.html(activated?Icons.ic_checked.toString():Icons.ic_checkbox.toString())
  },
  memberorderclear(){
    clearMemberOrderFilter()
    modal.closeModal();
    amplify.publish('familyMemberChange')
    return false
  },
})

registerDragStart(".reorderable>*",async function(ev,dropPromiseBuilder){
  var  
    movingNode = $(this),
    potentialDrop = document.querySelectorAll('.reorderable>*') as NodeListOf<HTMLElement>,
    dropEvent = await dropPromiseBuilder(this,potentialDrop),
    dropNode = $(dropEvent.target as HTMLElement);

  var nodeBefore = null;
  if(dropNode.offset().top + dropNode.height()/2>dropEvent.clientY){
    nodeBefore = dropNode.prev();
    movingNode.detach().insertBefore(dropNode)
  }else{
    nodeBefore = dropNode;
    movingNode.detach().insertAfter(dropNode)
  }

})
